import { RHFRadioGroup, RHFTextField } from '@zeta-core';
import { object, string } from 'yup';
import { yesNoObject } from '../common/commons';

export const healthValidations = object().shape({
  areYouInGoodHealth: string(),
  anyMedicalConditions: object().shape({
    yesOrNo: string(),
    ifYesSpecify: string(),
  }),
  areYouSmoker: string(),
  anyPreexistingConditionsOrPastSurgeries: object().shape({
    yesOrNo: string(),
    ifYesSpecify: string(),
  }),
  anyHazardousHobbies: object().shape({
    yesOrNo: string(),
    ifYesSpecify: string(),
  }),
  doYouHavePractitioner: object().shape({
    yesOrNo: string(),
    name: string(),
    address: string(),
  }),
  doYouHaveMedicalInsurance: object().shape({
    yesOrNo: string(),
    policyNumber: string(),
  }),
  doYouHaveCriticalIllnessCoverage: object().shape({
    yesOrNo: string(),
    policyNumber: string(),
  }),
  doYouHaveDentalProceduresCoverage: object().shape({
    yesOrNo: string(),
    policyNumber: string(),
  }),
});

export const healthValidationsSchema = object().shape({
  client: healthValidations,
  partner: healthValidations,
});

export const healthDefault = {
  areYouInGoodHealth: '',
  anyMedicalConditions: {
    yesOrNo: '',
    ifYesSpecify: '',
  },
  areYouSmoker: '',
  anyPreexistingConditionsOrPastSurgeries: {
    yesOrNo: '',
    ifYesSpecify: '',
  },
  anyHazardousHobbies: {
    yesOrNo: '',
    ifYesSpecify: '',
  },
  doYouHavePractitioner: {
    yesOrNo: '',
    name: '',
    address: '',
  },
  doYouHaveMedicalInsurance: {
    yesOrNo: '',
    policyNumber: '',
  },
  doYouHaveCriticalIllnessCoverage: {
    yesOrNo: '',
    policyNumber: '',
  },
  doYouHaveDentalProceduresCoverage: {
    yesOrNo: '',
    policyNumber: '',
  },
};

export const healthDefaultValues = {
  client: healthDefault,
  partner: healthDefault,
};

export const HEALTH_TABLE_CONFIG = [
  {
    label: 'Are You In Good Health?',
    name: 'areYouInGoodHealth',
    component: RHFRadioGroup,
    options: yesNoObject,
    row: true,
    customColor: '#212B36',
  },
  {
    label: 'Any Medical Conditions?',
    name: 'anyMedicalConditions',
    component: RHFRadioGroup,
    twoFields: [
      {
        label: 'Yes Or No',
        name: 'yesOrNo',
        component: RHFRadioGroup,
        options: yesNoObject,
        row: true,
        customColor: '#212B36',
      },
      {
        label: 'If yes specify',
        placeholder: 'If yes specify',
        name: 'ifYesSpecify',
        component: RHFTextField,
      },
    ],
    options: yesNoObject,
  },
  {
    label: 'Are You a Smoker?',
    name: 'areYouSmoker',
    component: RHFRadioGroup,
    options: yesNoObject,
    row: true,
    customColor: '#212B36',
  },
  {
    label: 'Any Preexisting Conditions or Past Surgeries?',
    name: 'anyPreexistingConditionsOrPastSurgeries',
    component: RHFRadioGroup,
    twoFields: [
      {
        label: 'Yes Or No',
        name: 'yesOrNo',
        component: RHFRadioGroup,
        options: yesNoObject,
        row: true,
        customColor: '#212B36',
      },
      {
        label: 'If yes specify',
        name: 'ifYesSpecify',
        placeholder: 'If yes specify',
        component: RHFTextField,
      },
    ],
    options: yesNoObject,
  },
  {
    label: 'Do You Have Any Hazardous Hobbies?',
    name: 'anyHazardousHobbies',
    component: RHFRadioGroup,
    twoFields: [
      {
        label: 'Yes Or No',
        name: 'yesOrNo',
        component: RHFRadioGroup,
        options: yesNoObject,
        row: true,
        customColor: '#212B36',
      },
      {
        label: 'If yes specify',
        name: 'ifYesSpecify',
        placeholder: 'If yes specify',
        component: RHFTextField,
      },
    ],
    options: yesNoObject,
  },
  {
    label: 'Do You Have a Medical Practitioner?',
    name: 'doYouHavePractitioner',
    component: RHFRadioGroup,
    threeFields: [
      {
        label: 'Yes Or No',
        name: 'yesOrNo',
        component: RHFRadioGroup,
        options: yesNoObject,
        row: true,
        customColor: '#212B36',
      },
      {
        label: 'Practitioner Name',
        placeholder: 'Name',
        name: 'name',
        component: RHFTextField,
      },
      {
        label: '',
        name: '',
      },
      {
        label: 'Practitioner Address',
        placeholder: 'Address',
        name: 'address',
        component: RHFTextField,
      },
    ],
    options: yesNoObject,
  },
  {
    label: 'Do You Have Medical Insurance?',
    name: 'doYouHaveMedicalInsurance',
    component: RHFRadioGroup,
    twoFields: [
      {
        label: 'Yes Or No',
        name: 'yesOrNo',
        component: RHFRadioGroup,
        options: yesNoObject,
        row: true,
        customColor: '#212B36',
      },
      {
        label: 'Policy Number',
        name: 'policyNumber',
        placeholder: 'Policy Number',
        component: RHFTextField,
      },
    ],
    options: yesNoObject,
  },
  {
    label: 'Do You Have Critical Illness Coverage?',
    name: 'doYouHaveCriticalIllnessCoverage',
    component: RHFRadioGroup,
    twoFields: [
      {
        label: 'Yes Or No',
        name: 'yesOrNo',
        component: RHFRadioGroup,
        options: yesNoObject,
        row: true,
        customColor: '#212B36',
      },
      {
        label: 'Policy Number',
        name: 'policyNumber',
        placeholder: 'Policy Number',
        component: RHFTextField,
      },
    ],
    options: yesNoObject,
  },
  {
    label: 'Do You Have Dental Procedures Coverage?',
    name: 'doYouHaveDentalProceduresCoverage',
    component: RHFRadioGroup,
    twoFields: [
      {
        label: 'Yes Or No',
        name: 'yesOrNo',
        component: RHFRadioGroup,
        options: yesNoObject,
        row: true,
        customColor: '#212B36',
      },
      {
        label: 'Policy Number',
        name: 'policyNumber',
        placeholder: 'Policy Number',
        component: RHFTextField,
      },
    ],
    options: yesNoObject,
  },
];
